const axios = require('axios');

export const getRecommendationsGTech = async (
    domain,
    articleId,
    numberOfArticles,
    nameForStats,
) => {
    const wrapper = document.querySelector('#g-tech-recommendation--js');
    const isportArticles = document.querySelectorAll("[data-control = 'g-tech-recommendation']");
    const apiKey = 'cqzW6U6T3YanqWCg';
    const options = {
        userId: localStorage.getItem('bisko-sid'),
        domain: domain || window.location.host,
        currentId: articleId,
        size: numberOfArticles,
    };

    function eslintConsole(e) {
        console.log(e); //eslint-disable-line
    }

    const handleError = () => {
        isportArticles.forEach((content) => {
            content.style.display = 'inline-block';

            const articles = content.querySelectorAll('article');

            if (articles.length > 0) {
                articles.forEach((article) => {
                    article.dataset.gtechRec = 'C';
                });
            }
        });
    };

    try {
        const response = await axios.post(
            'https://isport-recommendation.gjirafa.tech/recommend',
            options,
            {
                headers: {
                    ApiKey: apiKey,
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                timeout: 100,
            },
        );

        const data = await response.data;

        if (response.status === 200) {
            import('./isport-template')
                .then((module) => {
                    module.isportTemplate(data, wrapper, nameForStats);
                })
                .catch((error) => {
                    eslintConsole(error);
                });
        }
    } catch (error) {
        handleError();
        eslintConsole(error);
    }
};
